import React from 'react';
import { useParams } from 'react-router-dom';
import parse, { domToReact } from 'html-react-parser';

import { guide } from '@api/axiosAPI';
import { unescapeHtml } from '@lib/utils';

const GuideTemplate = () => {
  const { ptnId } = useParams();

  // 가이드 조회 API
  const { data: guideData } = guide.getSvcChnlGuide(
    ['getSvcChnlGuide', ptnId],
    {
      enabled: !!ptnId,
    },
    ptnId
  );

  const openApp = (isAos) => {
    const now = Date.now();
    let storeUrl = '';

    if (isAos) {
      storeUrl = 'https://play.google.com/store/apps/details?id=kr.co.openit.healthup2';
      window.location.href = 'intent://open#Intent;scheme=healthup;end';
    } else {
      storeUrl = 'https://apps.apple.com/kr/app/%ED%97%AC%EC%8A%A4%EC%97%85/id6499256355';
      window.location.href = 'healthup://open';
    }

    // 앱이 없는 경우, 스토어 이동
    setTimeout(() => {
      if (Date.now() - now < 2500) {
        window.location.href = storeUrl;
        // window.open(`kakaotalk://web/openExternal?url=${storeUrl}`);
      }
    }, 1500);
  };

  const clickHandlers = {
    'btn-googleplay': () => openApp(true),
    'btn-appstore': () => openApp(false),
  };

  const options = {
    replace: (domNode) => {
      if (domNode.type === 'tag') {
        const props = { ...domNode.attribs };

        // click 이벤트 처리
        if (props['data-click-id'] && clickHandlers[props['data-click-id']]) {
          props.className = props.classname;
          delete props.classname;

          return (
            <div {...props} className={props.className} onClick={clickHandlers[props['data-click-id']]}>
              {domToReact(domNode.children, options)}
            </div>
          );
        }
      }
    },
  };

  return <>{guideData && parse(unescapeHtml(guideData.svcChnlGuidCtt), options)}</>;
};

export default GuideTemplate;
